
export class OrderStatus {
    id: number;
    name: string;

    constructor(id :number, name:string) {
        this.id = id;
        this.name = name;
    }


    public static GetList(): Array<OrderStatus> {
        return new Array<OrderStatus>(
            new OrderStatus(100, "ChartAndStock"),
            new OrderStatus(200, "ChartOnly"),
            new OrderStatus(300, "IgnoreInNextCycle"),
            new OrderStatus(400, "OnHold"),
            new OrderStatus(500, "Discontinue")
        );
    }

    public static Get(id: number): OrderStatus {
        var items = this.GetList();
        for (let item of items) {
            if (item.id == id) {
                return item;
            }
        }

        return new OrderStatus(id, "");
    }
}


// WEBPACK FOOTER //
// ./ClientApp/dto/OrderStatusEnum.ts